import Vue from 'vue'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import annotationsInit from 'highcharts/modules/annotations'
import highchartsMore from 'highcharts/highcharts-more'

annotationsInit(Highcharts)
// Registered once here, before any chart exists: its afterDrawChartBox handler
// reads chart.pane, which only charts created after the registration have, so
// registering it from a lazily loaded component crashed the charts already
// drawn (e.g. the report sparklines) on their next redraw.
highchartsMore(Highcharts)

Highcharts.theme = {
  colors: [
    '#27bad9',
    '#62ae52',
    '#d8413e',
    '#ef7b0b',
    '#3774ab',
    '#90cc84',
    '#f0ac4a',
    '#FFF263',
    '#6AF9C4',
  ],
  chart: {
    backgroundColor: 'transparent',
  },
  credits: {
    enabled: false,
  },
}
Highcharts.setOptions(Highcharts.theme)

Vue.use(HighchartsVue)
